module.exports = __webpack_public_path__ + "img/youhui1.952a21c9.png";